var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { display: "inline-block", position: "relative" },
      attrs: { id: "puzzle" }
    },
    [
      _c("div", { staticStyle: { position: "relative" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShow,
                expression: "isShow"
              }
            ],
            staticClass: "puzzle-container",
            on: { mouseenter: _vm.mouseenter, mouseleave: _vm.mouseleave }
          },
          [
            _c("div", { style: "position:relative;overflow:hidden;" }, [
              _c(
                "div",
                {
                  style:
                    "position:relative;width:" +
                    _vm.dataWidth +
                    "px;height:" +
                    _vm.dataHeight +
                    "px;"
                },
                [
                  _c("img", {
                    ref: "scream",
                    style: "height:" + _vm.dataHeight + "px;",
                    attrs: { id: "scream", src: _vm.imgRandom }
                  }),
                  _vm._v(" "),
                  _c("canvas", {
                    ref: "puzzleBox",
                    attrs: {
                      id: "puzzle-box",
                      width: _vm.dataWidth,
                      height: _vm.dataHeight
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "puzzle-lost-box",
                  style:
                    "left:" +
                    _vm.left_Num +
                    "px;width:" +
                    _vm.dataWidth +
                    "px;height:" +
                    _vm.dataHeight +
                    "px;"
                },
                [
                  _c("canvas", {
                    ref: "puzzleShadow",
                    attrs: {
                      id: "puzzle-shadow",
                      width: _vm.dataWidth,
                      height: _vm.dataHeight
                    }
                  }),
                  _vm._v(" "),
                  _c("canvas", {
                    ref: "puzzleLost",
                    attrs: {
                      id: "puzzle-lost",
                      width: _vm.dataWidth,
                      height: _vm.dataHeight
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  ref: "verTips",
                  class: "ver-tips" + (_vm.displayTips ? " slider-tips" : "")
                },
                [
                  _vm.verification
                    ? [
                        _c("i", {
                          staticStyle: { "background-position": "-4px -1207px" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { color: "#42ca6b" } }, [
                          _vm._v("验证通过")
                        ]),
                        _c("span")
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.verification
                    ? [
                        _c("i", {
                          staticStyle: { "background-position": "-4px -1229px" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("验证失败:")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "margin-left": "4px" } }, [
                          _vm._v("拖动滑块将悬浮图像正确拼合")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "re-btn", on: { click: _vm.refreshImg } },
              [_c("a")]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "slider-container",
          on: { mouseenter: _vm.mouseenter, mouseleave: _vm.mouseleave }
        },
        [
          _c("div", { staticClass: "slider-bar" }, [
            _c(
              "p",
              {
                staticClass: "slider-bar-text select-none",
                attrs: { onselectstart: "return false" }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.isSuccess
                      ? "验证通过"
                      : "按住左边滑块， 拖动完成上方拼图"
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isSuccess,
                expression: "isSuccess"
              }
            ],
            staticClass: "slider-btn"
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isSuccess,
                expression: "!isSuccess"
              }
            ],
            ref: "sliderBtn",
            staticClass: "slider-btn",
            on: { mousedown: _vm.startMove, touchstart: _vm.startMove }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }